import { Mail } from "lucide-react";
import { Link, useSearchParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="bg-accent/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <Mail className="text-accent h-8 w-8" />
          </div>
          <CardTitle className="font-heading text-primary text-2xl font-bold">
            Confirm your VELUX workspace access
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted mb-6">
            We&apos;ve sent a verification link to{" "}
            {email ? (
              <span className="text-foreground font-medium">{email}</span>
            ) : (
              "your email address"
            )}
            . Please click the link to verify your account before signing in and generating
            localized sales materials.
          </p>
          <p className="text-muted mb-6 text-sm">
            Didn&apos;t receive the email? Check your spam folder or ask your VELUX workspace admin
            to resend access.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
